import * as yup from 'yup'
import { CompanyDto } from './companyDto'

export class NeedsClusterReinstalledDetailsDto {
  vin?: string = undefined
  exporterCompany?: CompanyDto = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  importerStockNumber?: string = undefined

  clusterReinstallOdometerReadingMi?: number = undefined
  clusterReinstallOdometerReadingKm?: number = undefined
  clusterReinstallOdometerReadingMiDifference?: number = undefined

  isClusterReinstalled?: boolean = undefined
}

export const NeedsClusterReinstalledDtoSchema = yup.object({
  vin: yup.string().nullable(),
  exporterCompany: yup.mixed().nullable(),
  year: yup.number().nullable(),
  make: yup.string().nullable(),
  model: yup.string().nullable(),
  importerStockNumber: yup.string().nullable(),

  clusterReinstallOdometerReadingMi: yup.number().nullable(),
  clusterReinstallOdometerReadingKm: yup.number().nullable(),
  // clusterReinstallOdometerReadingDifference: yup
  //   .number()
  //   .nullable()
  //   .test('Mileage discrepancy detected: difference is below 0 or above 100', value => {
  //     if (value === null || value === undefined) return true
  //     return !(value < 0 || value >= 100)
  //   }),

  isClusterReinstalled: yup.boolean().nullable()
})
